// "Show more / less" button
import { useTranslations } from "next-intl";

import IconArrow from "@/icons/ui/navigation/arrow.svg";
import { cn } from "@/utils/cn";

export function ExpandButton({
  expanded,
  setExpanded,
  className,
  titleCollapsed = "Show more",
  titleExpanded = "Show less",
}: {
  expanded: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
  titleCollapsed?: string;
  titleExpanded?: string;
}) {
  const t = useTranslations();
  return (
    <button
      type="button"
      className={cn(
        `px-4 py-2 text-[1.5rem] flex items-center justify-center gap-[1rem]`,
        className,
      )}
      onClick={() => setExpanded((prev) => !prev)}
    >
      <span className="font-bold">
        {expanded ? t(titleExpanded) : t(titleCollapsed)}
      </span>
      <IconArrow
        className={cn(
          "w-[1.2rem] h-auto text-red",
          expanded ? "rotate-90" : "rotate-[270deg]",
        )}
      />
    </button>
  );
}
